import { createBrowserRouter } from 'react-router-dom'
import { AppLayout } from './components/layout/AppLayout'
import { AuthGuard } from './components/layout/AuthGuard'
import { DashboardPage } from './pages/DashboardPage'
import { ProjectPage } from './pages/ProjectPage'
import { NoteStylesPage } from './pages/NoteStylesPage'
import { TemplateWorkbenchPage } from './pages/TemplateWorkbenchPage'
import { DatabaseCleanupPage } from './pages/DatabaseCleanupPage'
import { LoginPage } from './pages/LoginPage'
import { JoinPage } from './pages/JoinPage'
import AdminToolsPage from './pages/AdminToolsPage'

export const router = createBrowserRouter([
  // 公开路由（无需登录）
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/join',
    element: <JoinPage />,
  },
  {
    path: '/admin-tools',
    element: <AdminToolsPage />,
  },
  // 受保护路由（需要登录 + 企业绑定）
  {
    path: '/',
    element: (
      <AuthGuard>
        <AppLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: '/',
        element: <DashboardPage />,
      },
      {
        path: '/project/:id',
        element: <ProjectPage />,
      },
      {
        path: '/note-styles',
        element: <NoteStylesPage />,
      },
      {
        path: '/template-workbench',
        element: <TemplateWorkbenchPage />,
      },
      {
        path: '/db-cleanup',
        element: <DatabaseCleanupPage />,
      },
    ],
  },
])
